import {NormalizedMidiInput} from "./NormalizedMidiInput";
import {IMidiInputArray} from "./IMidiInput";
import ISelectOption from "./view/common/ISelectOption";

export class NormalizedMidiInputArray extends Array<NormalizedMidiInput> implements IMidiInputArray {
  public getSelectOptions(): ISelectOption[] {
    const result = this.map((midiInput) => (
      {
        label: midiInput.getName(),
        value: midiInput.getId(),
      }
    ));

    return result;
  }

  public toString(): string {
    let result = "[";
    result += this.map((midiInput) => midiInput.toString()).join(", ");
    result += "]";
    return result;
  }
}